import * as React from 'react'
import { useCallback } from 'react'
import clsx from 'clsx'

import {
  PlusIcon,
  Tooltip,
  UnstyledButton,
  type UnstyledButtonProps,
  VisuallyHidden,
} from '@buffer-mono/popcorn'

import styles from './AddButton.module.css'
import { useCalendarContext } from './context'

interface AddButtonProps
  extends Omit<UnstyledButtonProps, 'onClick' | 'tabIndex'> {
  labelDate: string
  fullWidth?: boolean
  timestamp: number
}

export const AddButton = React.memo(
  ({
    labelDate,
    fullWidth = false,
    timestamp,
    className,
    ...props
  }: AddButtonProps): JSX.Element => {
    const {
      addItemProps: { onClick, ...attributes },
    } = useCalendarContext()

    const handleClick = useCallback((): void => {
      onClick(timestamp)
    }, [onClick, timestamp])

    return (
      <Tooltip content="Add a post">
        <UnstyledButton
          {...attributes}
          className={clsx(
            styles.addUpdateButton,
            {
              [styles.fullWidth]: fullWidth,
            },
            className,
          )}
          tabIndex={-1}
          onClick={handleClick}
          {...props}
        >
          <PlusIcon size={fullWidth ? 'small' : 'medium'} />
          <VisuallyHidden>Schedule post for {labelDate}</VisuallyHidden>
        </UnstyledButton>
      </Tooltip>
    )
  },
)

AddButton.displayName = 'AddButton'
